<template>
  <div class="card">
    <div class="image">
      <img :src="image">
    </div>
    <div class="content">
      <h3>{{title}}</h3>
      <h4>By {{director}}</h4>
      <p>{{summary}}</p>
    </div>
  </div>
</template>



<script>
export default {
  name: "FilmCard",
  props:["title","director","summary","image"]
}
</script>

<style scoped>
.card {
  display: grid;
  grid-template-columns: auto 1fr;
  background-color: #2c3e50;
  margin: 10px 20px;
  width: 95%;
  height: 95%;
  border-radius: 20px;
}

.image {
  max-width: 184px;
  max-height: 284px;
  grid-column: 1;
  grid-row: 1 / span 3;
  padding: 10px 10px 10px 10px;
}

.content {
  padding: 20px;
  box-sizing: border-box;
  grid-column: 2;
  grid-row: 1 / span 3;
}

h3, h4, p {
  margin: 0;
}
h3{
  color: darkgoldenrod;
}
h4{
  color: wheat;
}
p{
  color: white;
  margin: 10px;
}
</style>

